export default __webpack_public_path__ + "static/media/pageone.b10817fe.txt";